/* file description */

import React, { useCallback } from 'react';
import _, { cloneDeep } from 'lodash';
import { COLUMN_FROM } from './consts';
import { FIELD_LCP_TABLE_MAP } from './FIELD_LCP_TABLE_MAP';
import { MergeTableColumn, UseGetColumnByField } from './type';
import { isMobileEnv, Api as FetchAPI } from '@/utils';
import { EditRender, ViewRender } from '../component/EventCenter/';

/**
 * @desc: 映射低代码扳手类型(kind)与原子组件类型(SPField-valueType)的关系
 */
export const useGetColumnByField: UseGetColumnByField = ({
  columnFrom = COLUMN_FROM.TABLE,
  forceFieldProps = {},
  isMobile,
} = {}) =>
  useCallback(
    ({
      field,
      mode,
      mergeColumn = {}, // 包含规则处理的结果
      moduleInfo,
      queryFormRef,
      isOpenGroup,
      setRowData,
      /** 在表格情况下，会拿到列表的全量数据 */
      rowsData,
      /** 全量的页面数据 */
      storeValue,
      /** 全量数据 + 数据变更方法 */
      store,
    }) => {
      const {
        kind,
        label,
        title,
        // fieldID,
        name,
        isRequired,
        extension = {},
      } = field;
      const targetColumn: MergeTableColumn = {
        moduleField: field,
        align: 'center',
        ...mergeColumn,
        title: title || label,
        dataIndex: name,
        sorter: true,
      };
      /**
       * 事件中心需要把extension里的events字段带入到colums上
       */
      targetColumn.events = extension?.events || [];

      // 搜索栏隐藏关联展示字段
      if (kind === 'LinkShowRecord') {
        targetColumn.search = false;
      }

      const transformFn = FIELD_LCP_TABLE_MAP.get(kind);
      if (!transformFn) {
        // console.warn(`暂时不支持低代码扳手类型 - ${kind}, 对应字段 ${label} - ${name}`);
        return targetColumn;
      }
      // transform params column

      transformFn({
        targetColumn,
        field,
        FetchAPI,
        columnFrom,
        moduleInfo,
        queryFormRef,
        isOpenGroup,
        mode,
        rowsData,
        setRowData,
        storeValue,
        store,
        isMobile: isMobile ?? isMobileEnv(),
      });

      // 通用属性处理 -start
      // 必填属性处理
      // 编辑模式下才做处理 add by hero
      if (mode !== 'view' && mode !== 'read') {
        if (targetColumn?.isRequired) {
          targetColumn.formItemProps = {
            ...(targetColumn.formItemProps || {}),
            rules: [
              {
                required: true,
                message: '此项为必填项',
              },
              ...(targetColumn?.formItemProps?.rules || []),
            ],
          };
        }
        if (isRequired && targetColumn?.isRequired === undefined) {
          targetColumn.formItemProps = {
            ...(targetColumn.formItemProps || {}),
            rules: [
              {
                required: true,
                message: '此项为必填项',
              },
              ...(targetColumn?.formItemProps?.rules || []),
            ],
          };
        }
      }

      if (field.extension?.tooltip) {
        targetColumn.formItemProps = {
          ...(targetColumn.formItemProps || {}),
          tooltip: field.extension?.tooltip,
        };
      }


      // if (extension?.isDisabled) {
      //   targetColumn.isDisabled = true;
      // }
      // targetColumn.fieldProps = (form) => {
      //   if (targetColumn.isDisabled || extension?.isDisabled) {
      //     return {
      //       ...targetColumn.fieldProps,
      //       disabled: targetColumn.isDisabled,
      //     };
      //   }
      //   return targetColumn.fieldProps;
      // };

      // 通用配置-不可修改处理
      const privateFieldProps = _.isFunction(targetColumn.fieldProps) ? targetColumn.fieldProps : cloneDeep(targetColumn.fieldProps);
      if (extension?.isDisabled || targetColumn.isDisabled !== undefined) {
        let disabledFieldValue: any[] = [];
        if (extension.disabledFieldValue) {
          disabledFieldValue = Array.isArray(extension.disabledFieldValue)
            ? extension.disabledFieldValue
            : extension.disabledFieldValue.split(',');
        }
        if (columnFrom === COLUMN_FROM.TABLE) {
          // targetColumn.editable = (text, record) => {
          //   if (targetColumn.isDisabled === true || targetColumn.isDisabled === false) {
          //     return !targetColumn.isDisabled;
          //   }
          //   if (!extension.disabledField || !extension.disabledFieldValue) {
          //     return false;
          //   } else {
          //     return !(disabledFieldValue.some(
          //       (item: string) => item === record[extension.disabledField],
          //     ));
          //   }
          // };
          // fix SPZN-9310 表格编辑情况下，通过editable控制会导致控件直接不显示，通过fieldProps控制是否可编辑
          // 简化代码，只保留最新的逻辑判定，如果有缺失，再添加
          targetColumn.fieldProps = (...arg) => {
            // mode === 'view' 为查看页页，默认关闭所有筛选项disabled
            const disabled =
              mode === 'view'
                ? false
                : extension.isDisabled || targetColumn.isDisabled;
            return {
              ...(_.isFunction(privateFieldProps) ? privateFieldProps(...arg) : privateFieldProps),
              disabled,
            };
          };
        } else {
          targetColumn.fieldProps = (form, ...arg) => {
            let isDisable = false;
            if (!extension.disabledField || !extension.disabledFieldValue) {
              isDisable = true;
            } else {
              isDisable = disabledFieldValue.some(
                (item: string) =>
                  item === form.getFieldValue(extension.disabledField),
              );
            }
            if (
              targetColumn.isDisabled === true ||
              targetColumn.isDisabled === false
            ) {
              isDisable = targetColumn.isDisabled;
            }
            return {
              ...(_.isFunction(privateFieldProps) ? privateFieldProps(form, ...arg) : privateFieldProps),
              disabled: isDisable,
            };
          };
        }
      }
      if (Object.keys(forceFieldProps)?.length > 0) {
        for (const fieldName in forceFieldProps) {
          if (targetColumn.dataIndex === fieldName) {
            const fieldProps = forceFieldProps[fieldName];
            if ('editable' in fieldProps) {
              targetColumn.editable = fieldProps.editable;
              targetColumn.fieldProps = {
                ...targetColumn.fieldProps,
                disabled: !fieldProps.editable,
              };
            }
            if ('required' in fieldProps) {
              targetColumn.formItemProps = {
                ...(targetColumn.formItemProps || {}),
                rules: [
                  {
                    required: fieldProps.required,
                    message: '此项为必填项',
                  },
                  ...(targetColumn?.formItemProps?.rules || []),
                ],
              };
            }
          }
        }
      }

      /**
       * 用于将详情页展示的数据收集
       * @param value 显示值
       * @param rowIndex 行号，如果是行数据，则需要
       */
      /**
       * 将详情的数据存储下来，比如用户id，在详情页中会转化为名称，此处存储名称
       */
      const targetRender = targetColumn.render;
      targetColumn.render = (value, config, ...arg) => {
        const setViewValue = (v: any) => {
          // 行数据处理
          if (_.isNumber(config.rowIndex)) {
            store?.setViewValuesByKey([moduleInfo.handle, config.rowIndex, targetColumn.dataIndex], v);
          } else {
            store?.setViewValuesByKey([moduleInfo.handle, targetColumn.dataIndex], v);
          }
        };
        const res = targetRender ? targetRender(value, { ...config, setViewValue }, ...arg) : value;
        // render如果返回的数据为文本，则统一处理，否则需要业务组件内部手动处理
        if (!React.isValidElement(res)) {
          setViewValue(res);
        }
        return res;
      };

      /**
       * 捕获onChange事件触发，没有renderFormItem的业务组件捕获不到
       */
      const renderItemFun = targetColumn.renderFormItem;
      if (renderItemFun) {
        targetColumn.renderFormItem = (value, config, ...arg) => {
          return (
            <EditRender
              config={config}
              field={{ ...field, moduleName: moduleInfo.handle }}
              rowIndex={config.rowIndex}
            >
              {renderItemFun(value, config, ...arg)}
            </EditRender>
          );
        };
      }

      /**
       * 捕获onClick事件触发
       */
      const renderEventFun = targetColumn.render;
      if (renderEventFun) {
        targetColumn.render = (value, config, ...arg) => {
          return (
            <>
              {
                React.createElement(ViewRender, {
                  value,
                  field: { ...field, moduleName: moduleInfo.handle },
                  rowIndex: config.rowIndex,
                  rowData: config.from === 'table' ? config.formValue?.[config.rowIndex] : config.formValue,
                  children: renderEventFun(value, config, ...arg),
                })
              }
            </>
          );
        };
      }

      // 自定义renderFormItem
      if (mergeColumn?.renderFormItem) {
        targetColumn.renderFormItem = mergeColumn.renderFormItem;
      }

      // 通用属性处理 - end
      return targetColumn;
    },
    [columnFrom, forceFieldProps, isMobile],
  );
